const PusherEventNames = {
  ADD_NOTIFICATION: "addNotification",
  UPDATE_COUNTS: "updateCounts",
  UPDATE: "update",
  LOGOUT: "logout",
  UPDATE_SYNC_STATUS: "updateSyncStatus"
} as const;

export default PusherEventNames;
